import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import ClaimTrendsComponent from './ClaimAnalysisTrends';
import { createSelector } from 'reselect';
import { selectClientListTiny } from '../../../../store/selectors/clients';
import { setClaimAnalysisTrendsFilter } from '../../../../store/actions/statistics';
import { createNumberDataField, createPlainDateField} from '../../../../util/format';

const selectFields:any = createSelector(
    (state)=> {
        const frequency =
            state?.statistics?.remitsAndPayersfilters?.frequency?.toLowerCase();
        return frequency === "monthly" || frequency === "weekly";
    },
    (isMonthly) => [
        createNumberDataField('count', 'Claim Analyzed Count', { sortable: true,width:195 }),
        createPlainDateField('periodLabel', 'Period',{ sortable: true,isString:isMonthly}),
    ]
);


const selectSelectedClient = createSelector(
    selectClientListTiny,
    (state) => state.dashboards.selectedClient,
    (clients: any, selectedClient: number) =>
        clients?.find((item) => item?.clientId === selectedClient)?.clientId
);

export const ClaimsTrendsPage = injectIntl(
    connect(
        (state:any) => ({
            filters:state.statistics.claimAnalysisTrendsfilters ,
            clients: selectClientListTiny(state),
            getStatsPending: state.statistics.getRemitPayersAndStatisticsPending.pending,
            fields: selectFields(state),
            selectedClient:selectSelectedClient(state)
        }),
        (dispatch) => ({
            actions: bindActionCreators({
                setStatisticsFilter: setClaimAnalysisTrendsFilter,
            }, dispatch)
        })
    )(ClaimTrendsComponent));